import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const StretchVertical: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['rect', { width: '6', height: '20', x: '4', y: '2', rx: '2' }],
    ['rect', { width: '6', height: '20', x: '14', y: '2', rx: '2' }],
  ],
];

export default StretchVertical;
